import { create } from "zustand";
import { devtools } from "zustand/middleware";
import { getSubOrganizations, searchSubOrg } from "../../api";

const initialState = {
  organizationList: [],
  pageCount: 0,
  currentPage: 1,
  selectedOrganizationId: null,
  selectedOrganization: null,
  selectedOrganizationData: null,
  orgFilterSearchQuery: {
    search: "",
    sortBy: "id",
    sortValue: "DESC",
    page: 1,
    organization_id: "",
  },
  orgs: [],
  subOrgs: [],
  adminUsers: [],
  emsOffices: [],
  zohoUsers: [],
  departments: [],
  editOrganization: false,
  addOrganizationModalOpen: false,
  totalItems: 0,
  itemsPerPage: 10,
};

const useOrganizationStore = create(
  devtools((set, get) => ({
    ...initialState,
    setOrganizationList: (list) => set({ organizationList: list }),
    setPageCount: (count) => set({ pageCount: count }),
    setCurrentPage: (page) => set({ currentPage: page }),
    setActiveOrg: (org) => set({ activeOrg: org }),
    setOrgFilterSearchQuery: (query) =>
      set((state) => ({
        orgFilterSearchQuery: {
          ...state.orgFilterSearchQuery,
          ...query,
        },
      })),
    setOrgs: (orgs) => set({ orgs }),
    setSelectedOrganizationId: (id) => set({ selectedOrganizationId: id }),
    setSelectedOrganization: (org) => set({ selectedOrganization: org }),
    setSelectedOrganizationData: (update) =>
      set((state) => ({
        selectedOrganizationData:
          typeof update === "function"
            ? update(state.selectedOrganizationData)
            : update,
      })),
    setSubOrgs: (subOrgs) => set({ subOrgs }),
    updateSubOrgs: (subOrg) =>
      set((state) => ({
        subOrgs: [...state.subOrgs, subOrg],
      })),
    setAdminUsers: (users) => set({ adminUsers: users }),
    setEMSOffices: (offices) => set({ emsOffices: offices }),
    setZohoUsers: (users) => set({ zohoUsers: users }),
    setDepartments: (departments) => set({ departments: departments }),
    loginAs: (userId) => {
      // ToDo: implement passing a query param named v2? to the URL so as to redirect to /v2
      window.location.href = `/admin/user/switch/start/${userId}`;
    },
    stopLoginAs: () => {
      window.location.href = "/admin/user/switch/stop";
    },
    setEditOrganization: (edit) => set({ editOrganization: edit }),
    setAddOrganizationModalOpen: (open) => set({ addOrganizationModalOpen: open }),
    setTotalItems: (total) => set({ totalItems: total }),
    setItemsPerPage: (items) => set({ itemsPerPage: items }),
    reset: () => set(initialState),
  })),
);

export default useOrganizationStore;
